<template>
  <NuxtImg v-slot="{ src, isLoaded, imgAttrs }" :alt="$attrs.alt" :custom="true">
    <LogoSmall v-if="!src" class="fill-neutral-300" :alt="$attrs.alt" :class="$attrs.class" />
    <img
      v-else-if="isLoaded"
      v-bind="imgAttrs"
      :id="id"
      :data-testid="`${id}-image`"
      :src="src"
      :alt="$attrs.alt as string"
      :class="$attrs.class"
    />
    <LogoSmall v-else class="animate-pulse fill-neutral-300" :alt="$attrs.alt" :class="$attrs.class" />
  </NuxtImg>
</template>

<script setup lang="ts">
import LogoSmall from 'assets/images/logo-small.svg';

import type { ImageProps } from '~/components/ui/Image/types';

defineProps<ImageProps>();
</script>
